import { Box, Flex, useDisclosure } from "@chakra-ui/react";
import { KnowledgeBaseHelperTopics, ToolbarFeatures } from "../../types";
import { Toolbar } from "../../components/toolbar/Toolbar";
import GridLayout from "./canvas/GridLayout";
import React, { useEffect } from "react";
import { useAtomValue } from "jotai";
import { PositionStateAtom, TransactionsAtom } from "../../store";
import { SampleDataModal, shouldShowSampleDataModal } from "../../components/modals/SampleDataModal";

export const Dashboard = () => {
  const positionState = useAtomValue(PositionStateAtom);
  const transactionState = useAtomValue(TransactionsAtom);
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    try {
      (window as any).$crisp.push([
        "set",
        "session:event",
        ["user:visitDashboardPage"],
      ]);
    } catch (e) {
      console.log(e);
    }
  }, []);

  // Check if user has no trades or positions and show modal
  useEffect(() => {
    const hasNoData = 
      positionState.positions.length === 0 && 
      transactionState.trades.length === 0;
    
    if (hasNoData && shouldShowSampleDataModal()) {
      // Add a small delay to ensure the dashboard has loaded
      const timer = setTimeout(() => {
        onOpen();
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [positionState.positions.length, transactionState.trades.length, onOpen]);

  return (
    <Flex h="full" direction="column" pt="1px">
      <Toolbar
        enabledOptions={[
          ToolbarFeatures.FILTER_SELECTOR,
          ToolbarFeatures.UNDERLYING,
          ToolbarFeatures.HELP,
          ToolbarFeatures.PRICING_QUEUE,
          ToolbarFeatures.TAGS,
          ToolbarFeatures.INSIGHTS,
          ToolbarFeatures.POSITION_GROUPING,
          ToolbarFeatures.BOOKS,
          ToolbarFeatures.DATE_RANGE,
          ToolbarFeatures.STRATEGY,
          ToolbarFeatures.CLEAR,
          ToolbarFeatures.DASHBOARD_SELECTOR,
          ToolbarFeatures.HELP,
        ]}
        helpKey={KnowledgeBaseHelperTopics.DASHBOARD}
      />
      <GridLayout />
      <Box h="400px" w="100%"></Box>
      
      <SampleDataModal isOpen={isOpen} onClose={onClose} />
    </Flex>
  );
};
